import { showNotification, showSuccess, showError, showWarning, showInfo } from './notification.js';

window.wpbuoy = window.wpbuoy || {}
window.wpbuoy.login = window.wpbuoy.login || {}

window.wpbuoy.login.submit = function(e) {
  e.preventDefault()

  const form = e.target
  const username = form.querySelector('[name="username"]')
  const password = form.querySelector('[name="password"]')
  const remember = form.querySelector('[name="rememberme"]:checked')
  const redirect = form.querySelector('[name="redirect"]')
  const nonce = form.querySelector('[name="nonce"]')
  const submit = form.querySelector('[type="submit"]')
  const formData = new FormData()

  submit.classList.add('loading')
  submit.disabled = true
  
  formData.append('action', 'wpbuoy_login')
  formData.append('username', username.value)
  formData.append('password', password.value)
  formData.append('remember', remember ? 1 : 0)
  formData.append('nonce', nonce.value)

  fetch(wpbuoy_ajax.ajax_url, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {  
      window.location.href = redirect.value
    } else {
      showError(data.data.message)
    }
  })
  .catch(error => {
    showError('An error occurred. Please try again.')
  })
  .finally(() => {
    submit.classList.remove('loading')
    submit.disabled = false
  })
}

window.wpbuoy.login.eventListeners = function() {
  const loginForms = document.querySelectorAll('.wpbuoy-login-form')
  loginForms.forEach(form => {
    form.addEventListener('submit', window.wpbuoy.login.submit)
  })
}

window.wpbuoy.login.eventListeners()
